export default __webpack_public_path__ + "static/media/AE1151.c4a6b0ee.exe";